import titleImage from "../../assests/images/welcome.png";
import avatarImage from "../../assests/images/avatar.png";

export default function WelcomeBox(props) {
    return (
        <div className="bg-white rounded-md overflow-hidden pb-8">

            <div className="flex justify-between bg-gray-200 p-4 relative">
                <div>
                    <h1 className="font-bold text-xl">{props.title}</h1>
                    <p className="text-gray-500 text-sm">{props.subtitle}</p>
                </div>

                <div>
                    <img src={titleImage} alt="" className="w-52" />
                </div>
                <img src={avatarImage} alt="" className="absolute w-14 -bottom-6 shadow-0b3swhite shadow-gray-100  rounded-full border-2 border-white" />
            </div>
            <div>
                {props.children}
            </div>

        </div>
    )
}